import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink href="https://g.page/sushi-musa-langley-city?share">
              <CFImage src={mobileMap} w="100%" alt="Sushi Musa Map" />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink href="https://g.page/sushi-musa-langley-city?share">
              <CFImage src={locationMap} w="100%" alt="Sushi Musa Map" />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
